import React from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';

import Navbar from '../Navbar/NavBar';
import AccountMain from './AccountMain';
import { useRouter } from '../../helpers/customHooks';
import Alerting from 'components/Alerting/Alerting';
import { Col, Row } from 'react-bootstrap';
import { useUserState } from 'store/hooks';
import { getTeamProps } from 'helpers';
import AccountInfo from './AccountInfo';

const ACCOUNT_TABS = ['info', 'players', 'alerting'];

export default () => {

  const { push, params } = useRouter();
  const { tab }: { tab?: string } = params;
  const user = useUserState();
  const teamId = user.teamId;
  const league = (getTeamProps(teamId) || { league: '' }).league;

  return (
    <>
      <Navbar />
      <Container className="container-00">
        <h4 className="h-t">Account</h4>
        <Tabs
          defaultActiveKey={tab && ACCOUNT_TABS.includes(tab) ? tab : 'players'}
          id="account-tabs"
          mountOnEnter
          unmountOnExit
          onSelect={(e: string | null) => push({ pathname: '/account/' + e })}
        >
          <Tab eventKey="info" title={`Account Info & Users`}>
            <AccountInfo/>
          </Tab>
          <Tab eventKey="players" title={`Players`}>
            <AccountMain />
          </Tab>
          
          <Tab eventKey="alerting" title={`Live Alerting`}>
          <Row>
          <Col lg={12} xs={12} style={{ height: 'calc(100vh - 265px)' }}>
          <div className="head-account">
            <h5>Live Alerting Settings</h5>
            </div>
            <div
            style={{
              height: 'calc(100vh - 188px)',
              position: 'relative',
              border: '2px solid rgba(219, 225, 229, 0.6)'
            }}
          >
            <div style={{ height: '100%' }}>
          <Alerting teamId={teamId} league={league} accountPage={true}/>
          </div>
          </div>
          </Col>
          </Row>
          </Tab>
        </Tabs>
      </Container>
    </>
  );
};
